/* Unconform — Collection/Shop filters & sort. Dependency-free.
   Filters the editable product cards by their data-goal / data-format and
   sorts by the price shown on the card. Works on the static card grid (the
   store's products are drafts and can't power a live collection loop yet). */
(function () {
  function init(root) {
    var bar = root.querySelector('[data-uc-filter]');
    var grid = root.querySelector('.grid');
    if (!bar || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
    var orig = cards.slice();
    var noRes = root.querySelector('[data-no-results]');
    var state = { goal: 'all', format: 'all', sort: 'featured' };

    function priceOf(c) {
      var el = c.querySelector('.price .now') || c.querySelector('.price');
      var n = parseFloat((el ? el.textContent : '').replace(/[^0-9.]/g, ''));
      return isNaN(n) ? 0 : n;
    }

    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (state.goal === 'all' || c.getAttribute('data-goal') === state.goal) &&
                 (state.format === 'all' || c.getAttribute('data-format') === state.format);
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      var vis = cards.filter(function (c) { return c.style.display !== 'none'; });
      var order;
      if (state.sort === 'price-asc') { order = vis.slice().sort(function (a, b) { return priceOf(a) - priceOf(b); }); }
      else if (state.sort === 'price-desc') { order = vis.slice().sort(function (a, b) { return priceOf(b) - priceOf(a); }); }
      else { order = orig.filter(function (c) { return vis.indexOf(c) > -1; }); } // featured / newest = original order
      order.forEach(function (c) { grid.appendChild(c); });
      if (noRes) { noRes.hidden = shown !== 0; }
    }

    bar.querySelectorAll('[data-filter]').forEach(function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        var t = p.getAttribute('data-filter');
        state[t] = p.getAttribute('data-value');
        bar.querySelectorAll('[data-filter="' + t + '"]').forEach(function (o) { o.classList.toggle('on', o === p); });
        apply();
      });
    });

    var sel = bar.querySelector('[data-sort]');
    if (sel) sel.addEventListener('change', function () { state.sort = sel.value; apply(); });

    var clr = root.querySelector('[data-clear-filters]');
    if (clr) clr.addEventListener('click', function (e) {
      e.preventDefault();
      state.goal = 'all'; state.format = 'all';
      bar.querySelectorAll('[data-filter]').forEach(function (o) { o.classList.toggle('on', o.getAttribute('data-value') === 'all'); });
      apply();
    });

    apply();
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('.uc-coll')).forEach(init);
  });
})();
